//GameBoard.js
import "./GameBoardActivities/memoryGame.css";  
import React, { useState, useEffect } from "react";
import MemoryGameEventPlannerData from "./Datasets/memory_game_event_planner_data";
import MemoryGameLibraryData from "./Datasets/memory_game_library_data";
import MemoryGameCard from "./memory_game_card";
import shuffleArr from "../../objects/CommonUse/shuffleArray";
import { determineFriendComment } from './objects/determine_friend_comment';
import { displayFriendComment } from './objects/display_friend_comment';
import determineMemoryBoardClasses from "./objects/determine_memory_board_classes";

function MemoryGame(props) {
    const [cardsArray, setCardsArray] = useState([]); 
    const [moves, setMoves] = useState(0);
    const [firstCard, setFirstCard] = useState(null);
    const [secondCard, setSecondCard] = useState(null);
    const [stopFlip, setStopFlip] = useState(false); 
    const [maxNbrMatches, setMaxNbrMatches] = useState(0);
    const [nbrMatched, setNbrMatched] = useState(0);
    const [rulesText] = useState(props.rulesText);
    const [nbrColumns] = useState(props.width);
    const [nbrRows] = useState(props.height);
    const [boardClass, setBoardClass] = useState("");
    const [score, setScore] = useState(props.score);
    const [nbrGames] = useState(props.nbrGames);
    const [gamesPlayed, setGamesPlayed] = useState(0);
    const [gameComplete, setGameComplete] = useState(false);
    const [activityName] = useState(props.activityName);
    const [finishButton, setFinishButton] = useState(false);
    const [perfectGameCount, setPerfectGameCount] = useState(0);
    const [maximumPoints, setMaxPoints] = useState(0);
    const [cumulativeScore, setCumScore] = useState(0);
    const [gameScore, setGameScore] = useState(0);
    const [disabledButton, setDisabledButton] = useState(false);
    const [levelNbr] = useState(props.levelNbr)
    const [gameType] = useState(props.gameType)
    const [cardType, setCardType] = useState("back cover-size");
    const [displayFriend, setDisplayFriend] = useState(false);
    const [comment, setComment] = useState("");
    const [commentNbr, setCommentNbr] = useState(1);
    const [totalNbrObjects] = useState(nbrRows * nbrColumns);
    const [displayFriendChk, setDisplayFriendChk] = useState();
    const [containerClass, setContainerClass] = useState("memoryGameContainer");
     
    //this function start new Game
    function NewGame() {
        const selectedItemArr = selectMemoryItems();
        setGameComplete(false);
        setTimeout(() => {
            const randomOrderArray = shuffleArr(selectedItemArr);
            setCardsArray(randomOrderArray);
            setMoves(0);
            setFirstCard(null);
            setSecondCard(null);
            setNbrMatched(0);
            setDisabledButton(true);
        }, 1000);
    }
    
    function initializeScore(){
        if (!isNaN(props.score.nbrAttempted)){
            setGamesPlayed(props.score.nbrAttempted);
        }
        if (!isNaN(props.score.points)){
            setCumScore(props.score.points);
        }
    }

    function setGameBoardClass() {
        let displayFriendChk = displayFriendComment(props.activityCategory, props.friendInfo);
        setDisplayFriendChk(displayFriendChk);
        const boardClasses = determineMemoryBoardClasses(nbrColumns, displayFriendChk,
            gameType );
        setContainerClass(boardClasses.containerClass);
        setBoardClass(boardClasses.boardClass);
        setCardType(boardClasses.cardType);
    }

    function selectMemoryItems(){
        let uniqueItemArr = [];
        let memoryData = [];
        if (gameType === "SideHustle"){
            memoryData = JSON.parse(JSON.stringify(MemoryGameEventPlannerData));
        }else{
            memoryData = JSON.parse(JSON.stringify(MemoryGameLibraryData));
        }
        for (let i=0; i<memoryData.length; i++){
            let itemName = memoryData[i].name;
            if (!uniqueItemArr.includes(itemName)){
                uniqueItemArr.push(itemName);
            }
        }
        const numberOfItems = totalNbrObjects / 2;
        setMaxNbrMatches(numberOfItems);
        uniqueItemArr = shuffleArr(uniqueItemArr);
        const totalLength = uniqueItemArr.length;
        uniqueItemArr.splice(numberOfItems, totalLength);
        let selectedItemArr = [];
        for (let i=0; i<memoryData.length; i++){
            let itemName = memoryData[i].name;
            const memoryObj = memoryData[i];
            if (uniqueItemArr.includes(itemName)){
                if (memoryObj.type === "picture"){
                    memoryObj.itemImg = "./assets/Activities/" + gameType + "/MemoryGame/" + memoryObj.itemImg;
                };
                selectedItemArr.push(memoryObj);
            }
        }
        selectedItemArr = shuffleArr(selectedItemArr);
        return selectedItemArr;
     }

    //this function helps in storing the firstCard and secondCard value
    function handleSelectedCards(item) {
        if (firstCard !== null && firstCard.id !== item.id) {
            setSecondCard(item);
        } else {
            setFirstCard(item);
        }
    }

    // if two have been selected then we check if the images are same or not,
    //if they are same then we stop the flipping ability
    // else we turn them back
    useEffect(() => {
        if (firstCard && secondCard) {
            setStopFlip(true);
            setDisplayFriend(false);
            if (firstCard.name === secondCard.name) {
                setCardsArray((prevArray) => {
                    return prevArray.map((unit) => {
                        if (unit.name === firstCard.name) {
                            return { ...unit, matched: true };
                        } else {
                            return unit;
                        }
                    });
                });
                const nbrCorrect = nbrMatched + 1;
                if (displayFriendChk === true){
                    determineIfTimeForFriend(nbrCorrect);
                }
                setNbrMatched(nbrCorrect);
                let nbrGamesPlayed = 0;
                if (nbrCorrect === maxNbrMatches){
                    nbrGamesPlayed = gamesPlayed + 1;
                    setGamesPlayed(nbrGamesPlayed);
                    calculateScore(nbrGamesPlayed);
                    setGameComplete(true);
                    setDisabledButton(false);
                }
                if (nbrGamesPlayed === nbrGames){
                    setFinishButton(true);
                }else{
                    removeSelection();
                }
            } else {
                setTimeout(() => {
                    removeSelection();
                }, 1000);
            }
        }
    }, [firstCard, secondCard]);

    function determineIfTimeForFriend(nbrCorrect){
        let displayFriendNow = false;
        const divisor = (totalNbrObjects / 4).toFixed(0);
        const remainder = +nbrCorrect % +divisor;
        if (remainder === 0){
            displayFriendNow = true;
        }
        if (displayFriendNow === true){
            friendComment();
            setDisplayFriend(true);
        }
    }

    function friendComment(){
        if (displayFriendChk === true){
            let commentTable = props.friendInfo.commentTable;
            let commentObj = determineFriendComment(commentTable, commentNbr);
            setComment(commentObj.comment);
            setCommentNbr(+commentObj.commentNbr);
        }
        setDisplayFriend();
    }

    //after the slected images have been checked for 
    //equivalency we empty the firstCard and secondCard component
    function removeSelection() {
        setFirstCard(null);
        setSecondCard(null);
        setStopFlip(false);
        setMoves((prevValue) => prevValue + 1);
    }

    function endGame() {
        score.points = cumulativeScore;
        score.maxScore = maximumPoints;
        score.nbrAttempted = gamesPlayed;
        score.gamesRemaining = nbrGames - gamesPlayed;
        score.newLevelEarned = false;
        if (gamesPlayed >= nbrGames){
            score.type = "finish";
            let scorePct = (+score.points / +score.maxScore) * 100;
            if (scorePct >= 80){
                score.newLevelEarned = true;
            }
        }else{
            score.type = "done";
        }
        setScore(score);
        props.onGameOver(score);
    }

    function calculateScore(nbrGamesPlayed){
        const newMaximumPoints = 100 * nbrGamesPlayed;
        setMaxPoints(newMaximumPoints);
        //  allow 'free moves' - 1 free moves per 4 objects 
        const P = totalNbrObjects / 2;
        const M100 = P + Math.sqrt(P);
        const alpha = 0.64;  // tuned to make 21 moves ≈ 70 at 18 objects
        // if 'alpha' increases than lower scores, reduce alpha to increase score (slight chgs)
        let score = 100 * Math.pow(M100 / moves, alpha);
        if (score  > 100){
             score = 100;
        }else{
            score = +score.toFixed(2);
        }
        if (score === 100){
            setPerfectGameCount(perfectGameCount + 1);
        }
        const newCumulativeScore = (+cumulativeScore + +score).toFixed(2);
        setGameScore(score);
        setCumScore(newCumulativeScore);
        const scoreObj = {totalScore: newCumulativeScore, perfectGameCount: perfectGameCount, 
             maxScore: newMaximumPoints, gamesPlayed: nbrGamesPlayed};
        return scoreObj;
    }

    //starts the game for the first time.
    useEffect(() => {
        setGameBoardClass();
        initializeScore();
        NewGame();
      }, []);

    return (
       
        <>      
            <div className={containerClass}>
            <h4 className="text-center font-weight-bold">{activityName} - Level {levelNbr}</h4>
            <h6 className="text-center mx-4">{rulesText}</h6>
            <div className={boardClass}>
             
                {cardsArray.map((item) => (
                    <MemoryGameCard
                        key={item.id}
                        item={item}
                        handleSelectedCards={handleSelectedCards}
                        toggled={
                            item === firstCard ||
                            item === secondCard ||
                            item.matched === true
                        }
                        stopflip={stopFlip}
                        cardType={cardType}
                    />
                ))}
            </div>
        </div>
            <div className="row">
                <div className="col-sm-6">
                    {!gameComplete ? (
                        <div className="mt-2 text-left font-weight-bold">Moves: {moves}</div>
                        ) : (
                        <div className="mt-2 text-left font-weight-bold">
                            Congratulations: You Won in {moves} moves
                        </div>
                    )}
                    {gamesPlayed > 0 ?
                        <div className="mt-2 text-left font-weight-bold">
                            <div> 
                                Game Score: {gameScore} &nbsp;&nbsp; Total Score: {cumulativeScore}  
                            </div>
                            <div>
                                Nbr Games Played: &nbsp; {gamesPlayed} &nbsp; of &nbsp;{nbrGames}
                            </div>
                        </div>
                    :
                        null
                    }
                </div>
                <div className="col-sm-6 mt-4">
                    {finishButton ?
                        <div className="d-flex justify-content-end">
                            <button className="button" onClick={endGame}>
                                Finish
                            </button>
                        </div>
                    :  
                        <div className="d-flex justify-content-end">
                            {disabledButton ?
                                <button className="button-disabled">
                                    New Game
                                </button>
                            :
                                <button className="button" onClick={NewGame}>
                                    New Game
                                </button>
                            }
                            <button className="button ml-4" onClick={endGame}>
                                Exit
                            </button>
                        </div>
                    }
                </div>
                         
            {displayFriend   ?
                  <span>
                      <div>
                          <img src={props.friendInfo.friendImgURL}  className="friend-memoryGame-position-img" 
                              alt="friendPicture"/>
                      </div>  
                      <div className="speech-memoryGame-position speech-puzzle-activity right" >
                          {comment}
                      </div>
                  </span>
                :
                    null
                }

    {/*
      {process.env.NODE_ENV === 'development' && (
                        <div className="breakpoint-indicator" />
                        )}
    */}
           </div>
          
    </>     

      
    );

}

export default MemoryGame;